import { navigation } from "./navigation";

export class RouteItem {
    icon = ''
    path = ''
    text = ''
    children = []

    constructor({ icon, path, text, children }) {
        this.icon = icon;
        this.path = path;
        this.text = text;
        this.children = children;
    }
}

const ReportsRouteItem = new RouteItem({
    icon: 'mdi-file-chart',
    path: navigation.main.reports.index,
    text: 'Reports',
})

const SrsCodesRouteItem = new RouteItem({
    icon: 'mdi-package',
    path: navigation.main.srsCodes.index,
    text: 'SRS Codes',
})

const UsersRouteItem = new RouteItem({
    icon: 'mdi-account-multiple',
    path: navigation.main.users.index,
    text: 'Users',
})

export const AdminRouteItems = [
    ReportsRouteItem,
    SrsCodesRouteItem,
    UsersRouteItem,
    // new RouteItem({
    //     icon: 'mdi-account-multiple',
    //     path: '',
    //     text: 'Users',
    //     children: [
    //         new RouteItem({
    //             icon: 'mdi-account',
    //             path: '/app/users',
    //             text: 'All Users',
    //             children: [],
    //             showChildren: false,
    //         }),
    //         new RouteItem({
    //             icon: 'mdi-account-cowboy-hat',
    //             path: '/app/corpUsers',
    //             text: 'Corp Users',
    //             children: [],
    //             showChildren: false,
    //         }),
    //     ],
    //     showChildren: false,
    // }),
];

export const VipRouteItems = [
    ReportsRouteItem,
    SrsCodesRouteItem,
]

export const SupplierRouteItems = [
    ReportsRouteItem,
    SrsCodesRouteItem,
]
